"use strict";

(function($) {
    $(function() {

        $('.js-show-order').click(function(){

            if(!$(this).parents('.order').find('.order__data').is(":visible")) {
                $(this).parents('.order').find('.btn').addClass('is-active');
            } else {
                $(this).parents('.order').find('.btn').removeClass('is-active');
            }

            $(this).parents('.order').find('.order__data').slideToggle(200);

        });

    });
})(jQuery);
